import React, { useState, useEffect } from 'react';

import { Container, Box, Typography, Button, Grid } from '@mui/material';
import OutlinedButton from '../CustomButton/OutlinedButton';

import imgThor from '../../assets/images/LeftBar/Bitmap.png';

import { IoIosArrowDown } from 'react-icons/io';

import styles from './style.module.css';
import { makeStyles } from '@material-ui/styles';

import {
  DEFAULT_TOKEN_DECIMAL,
  useApprove,
  useDeposit,
  useGetAllowance,
  useGetBalance,
  useGetTotalStaked,
  useGetTotalSupply,
  useGetUserInfo,
  useWithdraw,
} from '../../hooks/farm';

import { pools } from '../../utils/farm';
import BigNumber from 'bignumber.js';
import { getNumber } from '../../utils/utils';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useSelector } from 'react-redux';

const selectTypeData = [
  {
    img: imgThor,
    title: 'THOR - AVAX',
  },
  {
    img: imgThor,
    title: 'THOR',
  }
];

const useStyles = makeStyles((theme) => ({
  tabsBtn: {
    background: theme.palette.background.tabsBg,
    border: '1px solid',
    borderColor: theme.palette.border.tabsActiveBorder,
    color: theme.palette.text.light,
    '&:hover': {
      background: theme.palette.background.tabsBg,
    },
  },
}));



const BottomSection = ({farmType, setFarmType}) => {
  const web3context = useSelector((state) => state.web3.web3context);
  const [amount, setAmount] = useState(new BigNumber(0));  
  const poolConfig = pools[farmType]
  const [active, setActive] = useState(1);

  const { onApprove, isApproving } = useApprove(poolConfig.address);
  const { onDeposit, isDepositing } = useDeposit(poolConfig.pid);
  const { onWithdraw, isWithdrawing } = useWithdraw(poolConfig.pid);

  const allowance = useGetAllowance(poolConfig.address);
  const totalSupply = useGetTotalSupply(poolConfig.address);
  const totalStaked = useGetTotalStaked(poolConfig.address);
  const userInfo = useGetUserInfo(poolConfig.pid);
  const balance = useGetBalance(poolConfig.address);

  const isAllowed = allowance.data && new BigNumber(allowance.data).isGreaterThan(0);
  const totalAllocation = pools.map((p) => p.multiplier).reduce((a, b) => a + b, 0);

  const lpPrice = useQuery(
    ['lpPrice', poolConfig.pid, poolConfig.symbol],
    () => {
      return poolConfig.getPrice(web3context.library);
    },
    {
      refetchInterval: 60000 * 10,
      enabled: Boolean(totalSupply.data && web3context.library),
    },
  );
  

  const thorPrice = useQuery(
    'thorPrice',
    () => {
      return axios
        .get(
          'https://api.coingecko.com/api/v3/simple/token_price/avalanche?contract_addresses=0x8F47416CaE600bccF9530E9F3aeaA06bdD1Caa79&vs_currencies=USD',
        )
        .then((response) => response.data?.['0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79']?.['usd']);
    },
    {
      refetchInterval: 60000 * 10,
    },
  );

  const stakedRatio =
    thorPrice.data &&
    totalStaked.data &&
    lpPrice.data &&
    (770 * (poolConfig.multiplier / totalAllocation) * thorPrice.data) /
      (Number(getNumber(totalStaked.data)) * lpPrice.data);
  const APY = stakedRatio ? 365 * stakedRatio * 100 : 0;


  // 0 is THOR LP and 1 is THOR
  const handleFarmTypeChange = (idx) => {
    // setPoolConfig(pools[idx]);
    setFarmType(idx);
  };

  const handleTransaction = () => {
    if (!isAllowed) {
      onApprove();
    } else {
      if (active === 1) {
        onDeposit(new BigNumber(amount.toString()).times(DEFAULT_TOKEN_DECIMAL).toFixed());
      } else {
        onWithdraw(amount?.toString());
      }
    }
  };

  const setMax = () => {
    if (active === 1) {
      setAmount(new BigNumber(getNumber(balance.data, 18)));
    } else {
      setAmount(new BigNumber(getNumber(userInfo.data.amount, 18)));
    }
  };

  return (
    <>
      <BottomSectionDesktop
        isAllowed={isAllowed}
        userInfo={userInfo}
        balance={balance}
        lpPrice={lpPrice}
        active={active}
        amount={amount}
        APY={APY}
        handleFarmTypeChange={handleFarmTypeChange}
        handleTransaction={handleTransaction}
        setActive={setActive}
        setAmount={setAmount}
        setMax={setMax}
      />
      <BottomSectionMobile
        isAllowed={isAllowed}
        userInfo={userInfo}
        balance={balance}
        lpPrice={lpPrice}
        active={active}
        amount={amount}
        APY={APY}
        handleFarmTypeChange={handleFarmTypeChange}
        handleTransaction={handleTransaction}
        setActive={setActive}
        setAmount={setAmount}
        setMax={setMax}
      />
    </>
  );
};



const BottomSectionDesktop = ({
    handleFarmTypeChange,
    userInfo,
    balance,
    lpPrice,
    APY,
    active,
    setActive,
    setAmount,
    amount,
    isAllowed,
    handleTransaction,
    setMax    
}) => {
  // const [active, setActive] = useState(1);
  const [type, setType] = useState('THOR');
  const [typeDrpDwn, setTypeDrpDwn] = useState();
  const classes = useStyles();

  return (
    <Box
      marginTop={4}
      sx={{
        background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.48)',
        borderRadius: '10px',
        padding: 4,
        paddingTop: 10,
      }}
      display={{ xs: 'none', sm: 'none', md: 'none', lg: 'block' }}
    >
      <Box className={styles.roundBorder}>
        <Container maxWidth="sm">
          <Box
            width={'236px'}
            sx={{
              marginX: 'auto',
              marginTop: '-65px',
            }}
          >
            <Typography
              marginLeft={2}
              gutterBottom
              sx={{
                fontFamily: 'Kanit',
                color: 'white',
                opacity: 0.5,
                textAlign: 'center',
                fontSize: '14px',
              }}
            >
              Select type
            </Typography>

            <Box
              display={'flex'}
              justifyContent="space-between"
              alignItems={'center'}
              sx={{
                border: '1px solid rgba(255, 255, 255, 0.4)',
                borderRadius: '48px',
                paddingX: '10px',
                paddingY: '5px',
                position: 'relative',
                cursor: 'pointer',
              }}
              onClick={() => setTypeDrpDwn(!typeDrpDwn)}
            >
              <Box display="flex" alignItems="center">
                <img src={imgThor} alt="hammer" width={'32px'} height={'32px'} />
              </Box>
              <Typography
                variant="subtitle1"
                sx={{
                  fontFamily: 'Kanit',
                  color: 'white',
                  fontSize: '14px',
                  marginTop: '2.5px',
                }}
              >
                {type}
              </Typography>
              <Box>
                <IoIosArrowDown color="white" />
              </Box>
              {typeDrpDwn ? (
                <Box className={styles.select_typeDrp}>
                  {selectTypeData.map((d, index) => {
                    return (
                      <Box key={index} onClick={() => {setType(d.title); handleFarmTypeChange(index);}}>
                        <img src={d.img} alt="hammer" width={'32px'} height={'32px'} />
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontFamily: 'Kanit',
                            color: 'white',
                            fontSize: '14px',
                            marginTop: '2.5px',
                          }}
                        >
                          {d.title}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                ''
              )}
            </Box>
          </Box>
          <Box
            display={'flex'}
            justifyContent="space-between"
            flexDirection={{ xs: 'column', sm: 'row' }}
            marginTop={4}
          >
            <Box>
              <Typography
                marginLeft={2}
                sx={{
                  fontFamily: 'Kanit',
                  color: 'white',
                  opacity: 0.5,
                  fontSize: '20px',
                }}
              >
                Staked Amount
              </Typography>
              <Typography
                marginLeft={2}
                gutterBottom
                sx={{
                  background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                  fontFamily: 'Kanit',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  textFillColor: 'transparent',
                  fontStyle: 'normal',
                  WebkitTextFillColor: 'transparent',
                  fontWeight: 'bold',
                  fontSize: '36px',
                }}
              >
                {userInfo?.data && lpPrice.data
                  ? (Number(getNumber(userInfo.data.amount)) * lpPrice.data).toFixed(2)
                  : 0.0}
              </Typography>
            </Box>
            <Box>
              <Typography
                marginLeft={2}
                sx={{
                  fontFamily: 'Kanit',
                  color: 'white',
                  opacity: 0.5,
                  fontSize: '20px',
                }}
              >
                APR
              </Typography>
              <Typography
                marginLeft={2}
                variant="h4"
                gutterBottom
                sx={{
                  background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                  fontFamily: 'Kanit',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  textFillColor: 'transparent',
                  fontStyle: 'normal',
                  WebkitTextFillColor: 'transparent',
                  fontWeight: 'bold',
                  fontSize: '36px',
                }}
              >
                {APY ? APY.toFixed() : 0}%
              </Typography>
            </Box>
          </Box>

          <Box marginTop={4}>
            <Box
              maxWidth={'300px'}
              sx={{
                border: '1px solid #5C5C5C',
                borderRadius: '48px',
                overflowX: 'hidden',
                display: 'flex',
                marginX: 'auto',
              }}
            >
              <Box flex={1}>
                {active === 1 ? (
                  <Button
                    variant="contained"
                    className={classes.tabsBtn}
                    fullWidth
                    sx={{
                      borderRadius: '48px',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                    }}
                  >
                    deposit
                  </Button>
                ) : (
                  <Button variant="text" fullWidth sx={{ color: 'white' }} onClick={() => setActive(1)}>
                    deposit
                  </Button>
                )}
              </Box>
              <Box flex={1}>
                {active === 2 ? (
                  <Button
                    className={classes.tabsBtn}
                    variant="contained"
                    fullWidth
                    sx={{
                      borderRadius: '48px',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                    }}
                  >
                    withdraw
                  </Button>
                ) : (
                  <Button variant="text" fullWidth sx={{ color: 'white' }} onClick={() => setActive(2)}>
                    withdraw
                  </Button>
                )}
              </Box>
            </Box>
          </Box>

          <Grid container spacing={2} marginTop={4} display="flex" alignItems="center">
            <Grid item lg={8} md={8} sm={12} xs={12} position="relative">
              <input type="number" value={amount} className={styles.inputStyle} placeholder="Enter amount..." onChange={(e) => {
                  setAmount(e.target.value);
                }}/>
              <Box position={'absolute'} top={'35%'} right={'3%'}>
                <Typography
                  onClick={setMax}
                  variant="body2"
                  sx={{
                    color: 'white',
                    fontWeight: 'bold',
                    fontFamily: 'Kanit',
                    cursor: 'pointer'
                  }}
                >
                  MAX
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'white',
                    opacity: 0.5,
                    fontFamily: 'Kanit',
                    marginTop: '-3px',
                  }}
                >
                  {active === 1
                    ? balance.data
                      ? getNumber(balance.data, 2)
                      : 0.0
                    : userInfo.data
                    ? getNumber(userInfo.data.amount, 2)
                    : 0.0}
                </Typography>
              </Box>
            </Grid>
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <OutlinedButton paddingVertical={'10px'} paddingHorizontal="40px" fullWidth onClick={handleTransaction} label={isAllowed ? (active === 1 ? 'Deposit' : 'Withdraw') : 'Approve'}/>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

const BottomSectionMobile = ({
  handleFarmTypeChange,
  userInfo,
  balance,
  lpPrice,
  APY,
  active,
  setActive,
  setAmount,
  amount,
  farmType,
  isAllowed,
  handleTransaction,
  setMax,
}) => {
  // const [active, setActive] = useState(1);
  const classes = useStyles();
  const [type, setType] = useState('THOR');
  const [typeDrpDwn, setTypeDrpDwn] = useState();
  return (
    <Box
      marginTop={4}
      sx={{
        background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.48)',
        borderRadius: '10px',
        padding: 4,
        paddingTop: 10,
      }}
      display={{ xs: 'block', sm: 'block', md: 'block', lg: 'none' }}
    >
      <Box className={styles.roundBorderMobile}>
        <Box
          display={'flex'}
          justifyContent="space-between"
          alignItems={'center'}
          sx={{
            marginX: 'auto',
            zIndex:'999999',
            marginTop: '-30px',
            borderRadius: '48px',
            border: '1px solid rgba(255, 255, 255, 0.4)',
            padding: '5px 10px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          onClick={() => setTypeDrpDwn(!typeDrpDwn)}
        >
          <Box display="flex" alignItems="center">
            <img src={imgThor} alt="hammer" width={'32px'} height={'32px'} />
          </Box>
          <Typography
            variant="subtitle1"
            sx={{
              fontFamily: 'Kanit',
              color: 'white',
              fontSize: '14px',
              marginTop: '2.5px',
            }}
          >
            {type}
          </Typography>
          <Box>
            <IoIosArrowDown color="white" />
          </Box>
          {typeDrpDwn ? (
            <Box className={styles.select_typeDrp}>
              {selectTypeData.map((d, index) => {
                return (
                  <Box key={index} onClick={() => {setType(d.title); handleFarmTypeChange(index)}}>
                    <img src={d.img} alt="hammer" width={'32px'} height={'32px'} />
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontFamily: 'Kanit',
                        color: 'white',
                        fontSize: '14px',
                        marginTop: '2.5px',
                      }}
                    >
                      {d.title}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          ) : (
            ''
          )}
        </Box>
        <Container maxWidth="sm">
          <Box display={'flex'} justifyContent="space-between" alignItems={'center'} marginTop="20px">
            <Box sx={{ flex: 1, textAlign: 'center' }}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Kanit',
                    color: 'white',
                    opacity: 0.5,
                    fontSize: '10px',
                    fontWeight: 400,
                  }}
                >
                  Staked Amount
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                    fontFamily: 'Kanit',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    textFillColor: 'transparent',
                    fontStyle: 'normal',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 'bold',
                    fontSize: '24px',
                  }}
                >
                  {userInfo?.data && lpPrice.data
                    ? (Number(getNumber(userInfo.data.amount)) * lpPrice.data).toFixed(2)
                    : 0.0}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ flex: 1, textAlign: 'center' }}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Kanit',
                    color: 'white',
                    opacity: 0.5,
                    fontSize: '10px',
                    fontWeight: 400,
                  }}
                >
                  APR
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                    fontFamily: 'Kanit',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    textFillColor: 'transparent',
                    fontStyle: 'normal',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 'bold',
                    fontSize: '24px',
                  }}
                >
                  {APY ? APY.toFixed() : 0}%
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box marginTop={2}>
            <Box
              maxWidth={'300px'}
              sx={{
                border: '1px solid #5C5C5C',
                borderRadius: '48px',
                overflowX: 'hidden',
                display: 'flex',
                marginX: 'auto',
              }}
            >
              <Box flex={1}>
                {active === 1 ? (
                  <Button
                    className={classes.tabsBtn}
                    variant="contained"
                    fullWidth
                    sx={{
                      borderRadius: '48px',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                      fontSize: '10px',
                      fontWeight: '600',
                    }}
                  >
                    deposit
                  </Button>
                ) : (
                  <Button
                    variant="text"
                    fullWidth
                    sx={{ color: 'white', fontSize: '10px', fontWeight: '600' }}
                    onClick={() => setActive(1)}
                  >
                    deposit
                  </Button>
                )}
              </Box>
              <Box flex={1}>
                {active === 2 ? (
                  <Button
                    className={classes.tabsBtn}
                    variant="contained"
                    fullWidth
                    sx={{
                      borderRadius: '48px',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.64)',
                      fontSize: '10px',
                      fontWeight: '600',
                    }}
                  >
                    withdraw
                  </Button>
                ) : (
                  <Button
                    variant="text"
                    fullWidth
                    sx={{ color: 'white', fontSize: '10px', fontWeight: '600' }}
                    onClick={() => setActive(2)}
                  >
                    withdraw
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
          <Box marginTop={2} position="relative">
            <input type="text"  className={styles.inputStyle} placeholder="Enter amount..." 
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
            }}
            />
            <Box position={'absolute'} top={'20%'} right={'3%'} textAlign="end">
              <Typography
                onClick={setMax}
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  fontFamily: 'Kanit',
                  fontSize: '8px',
                  cursor: 'pointer'
                }}
              >
                MAX
              </Typography>
              <Typography
                sx={{
                  color: 'white',
                  opacity: 0.5,
                  fontFamily: 'Kanit',
                  marginTop: '-3px',
                  fontSize: '10px',
                }}
              >
                {active === 1
                  ? balance.data
                    ? getNumber(balance.data, 2)
                    : 0.0
                  : userInfo.data
                  ? getNumber(userInfo.data.amount, 2)
                  : 0.0}
              </Typography>
            </Box>
          </Box>
          <Box marginTop="10px">
            <OutlinedButton paddingVertical={'10px'} paddingHorizontal="40px" fullWidth onClick={handleTransaction} label={isAllowed ? (active === 1 ? 'Deposit' : 'Withdraw') : 'Approve'}/>
          </Box>
          <Box textAlign={'center'} marginTop={2}>
            <Typography
              sx={{
                fontFamily: 'Kanit',
                fontSize: '12px',
                fontWeight: 400,
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%)',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
              onClick={()=>window.open("https://traderjoexyz.com/trade?outputCurrency=0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79")}
            >
              Buy THOR-AVAX
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export { BottomSection };
